// This helps access the current token/user easily.

import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { selectCurrentToken } from "../features/auth/authSlice";

const useAuth = () => {
  const token = useSelector(selectCurrentToken);
  if (!token) return { isLoggedIn: false };

  const decoded = jwtDecode(token);
  const { id, roles, exp } = decoded;

  return {
    id,
    roles,
    isLoggedIn: true,
    token,
    exp,
  };
};

export default useAuth;
